import React from 'react';

/**
 * Frequency Display Component
 * Displays execution frequency in a user-friendly format
 *
 * Props:
 * - frequency: String (e.g., "288 times/day", "Every 18 hours")
 * - schedulingType: "Timer" or "Cron"
 *
 * Display:
 * - Shows frequency text
 * - Shows scheduling type badge below
 */
const FrequencyDisplay = ({ frequency, schedulingType }) => {
  return (
    <div className="frequency-display">
      <span className="d-block mb-1">
        {frequency || 'N/A'}
      </span>
      <span className={`badge badge-sm ${schedulingType === 'Cron' ? 'badge-primary' : 'badge-info'} d-none`}>
        {schedulingType}
      </span>
    </div>
  );
};

export default FrequencyDisplay;
